module.exports = __webpack_public_path__ + "img/12.48a6f518.png";